import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CookieConsentService } from '@app/services/ui/cookie-consent/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent {
  readonly cookieConsent = inject(CookieConsentService);

  openPreferences(): void {
    this.cookieConsent.openPreferences();
  }

  savePreferences(): void {
    this.cookieConsent.savePreferences(this.cookieConsent.preferencesAnalytics());
  }

  @HostListener('document:keydown.escape')
  closeOnEscape(): void {
    if (this.cookieConsent.preferencesOpen()) {
      this.cookieConsent.closePreferences();
    }
  }
}
